module.exports = __webpack_public_path__ + "static/portfolio3-e8fe8b2a33af0205ebc54c8250ccd057.png";